<app-select-filter *ngIf="!multiple"
                   [parentFormGroup]="parentFormGroup"
                   [parentFormControlName]="parentFormControlName"
                   noEntriesFoundLabel="Aucun utilisateur trouvé"
                   [filterElementProcessor]="filter"
                   [deletable]="true"
                   [loading]="loading"
                   [elements]="usersElements"
                   (_onSingleSelectionChange)="userSelectedEvent.emit($event.element)">

    <ng-template template-content let-element='element'>
        <div class="d-flex align-items-center">
            <app-user-avatar [user]="element" class="m-r-4"></app-user-avatar>{{element.name}}
        </div>
    </ng-template>
</app-select-filter>

<app-multiple-select-filter *ngIf="multiple"
                            [parentFormControlName]="parentFormControlName"
                            [parentFormGroup]="parentFormGroup"
                            [elements]="usersElements"
                            [filterElementProcessor]="filter"
                            [loading]="loading"
                            noEntriesFoundLabel="Aucun utilisateur trouvé">
    <ng-template template-content let-element='element'>
        <div class="d-flex align-items-center">
            <app-user-avatar [user]="element"></app-user-avatar>{{element.name}}
        </div>
    </ng-template>
</app-multiple-select-filter>
